import {NgModule, ModuleWithProviders, forwardRef} from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { FormlyBootstrapModule } from '@ngx-formly/bootstrap';
import { FileUploadModule } from 'ng2-file-upload';
import { TextMaskModule } from 'angular2-text-mask';


import { SharedModule } from '../../shared/shared.module';

import { WelcomeContainerComponent } from './welcome-container/welcome-container.component';
import { PersonalDetailContainerComponent } from './personal-detail-container/personal-detail-container.component';

import { TasksContainerComponent } from './tasks-container/tasks-container.component';
import { TaskQuestionsContainerComponent } from './task-questions-container/task-questions-container.component';

import { HtmlContentComponent } from '../components/html-content/html-content.component';
import { AttachmentComponent } from '../components/attachment/attachment.component';

import { NgbModule, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { NgSelectModule } from '@ng-select/ng-select';

import { QuestionWrapperComponent } from '../components/question-wrapper/question-wrapper.component';
import { InputWithAddonComponent } from '../components/input-with-addon/input-with-addon.component';
import { StaticTextComponent } from '../components/static-text/static-text.component';
import { TaskComponent } from '../components/task/task.component';
import { FileCheckboxComponent} from '../components/file-checkbox/file-checkbox.component';
import { FileUploadComponent } from '../components/file-upload/file-upload.component';
import { DatePickerComponent } from '../components/date-picker/date-picker.component';
import { MultiselectComponent } from './multiselect/multiselect.component';
import { MulticheckboxComponent } from './multicheckbox/multicheckbox.component';

import { formlyConfigs } from './formlyConfigs';
import { DocConfirmationContainerComponent } from './doc-confirmation-container/doc-confirmation-container.component';
import { DocConfirmationComponent } from '../components/doc-confirmation/doc-confirmation.component';

import { MobileNumberConfirmationComponent } from './mobile-number-confirmation/mobile-number-confirmation.component';
import { CountDownTimerComponent } from '../components/count-down-timer/count-down-timer.component';

import { GaugeModule } from 'angular-gauge';
import { FinalConfirmationContainerComponent } from './final-confirmation-container/final-confirmation-container.component';
import { BlockElementComponent } from '../components/block-element/block-element.component';
import { SubLoginContainerComponent } from './sub-login-container/sub-login-container.component';
import { ErrorStageContainerComponent } from './error-stage-container/error-stage-container.component';

import { CustomNgbDateParserFormatter } from '../services/customDateParserFormatter.service';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { Store } from '@ngrx/store';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TextMaskModule,
        ReactiveFormsModule,
        formlyConfigs,
        FormlyModule.forRoot(),
        FormlyBootstrapModule,
        SharedModule,
        FileUploadModule,
        NgbModule.forRoot(),
        NgxIntlTelInputModule,
        BsDropdownModule.forRoot(),
        NgSelectModule,
        GaugeModule.forRoot(),
       ],
    declarations: [
        WelcomeContainerComponent,
        TasksContainerComponent,
        HtmlContentComponent,
        AttachmentComponent,
        PersonalDetailContainerComponent,
        QuestionWrapperComponent,
        InputWithAddonComponent,
        StaticTextComponent,
        TaskComponent,
        FileCheckboxComponent,
        TaskQuestionsContainerComponent,
        FileUploadComponent,
        DocConfirmationContainerComponent,
        DocConfirmationComponent,
        MobileNumberConfirmationComponent,
        CountDownTimerComponent,
        DatePickerComponent,
        FinalConfirmationContainerComponent,
        BlockElementComponent,
        SubLoginContainerComponent,
        ErrorStageContainerComponent,
        MultiselectComponent,
        MulticheckboxComponent,
    ],
    exports: [
        WelcomeContainerComponent,
        TasksContainerComponent,
        PersonalDetailContainerComponent,
        TaskQuestionsContainerComponent,
        DocConfirmationContainerComponent,
        MobileNumberConfirmationComponent,
        FinalConfirmationContainerComponent,
        SubLoginContainerComponent,
        ErrorStageContainerComponent
    ],
    entryComponents: [
        WelcomeContainerComponent,
        TasksContainerComponent,
        PersonalDetailContainerComponent,
        TaskQuestionsContainerComponent,
        DocConfirmationContainerComponent,
        MobileNumberConfirmationComponent,
        FinalConfirmationContainerComponent,
        SubLoginContainerComponent,
        ErrorStageContainerComponent,
        HtmlContentComponent,
        AttachmentComponent,
        QuestionWrapperComponent,
        InputWithAddonComponent,
        StaticTextComponent,
        TaskComponent,
        FileCheckboxComponent,
        FileUploadComponent,
        CountDownTimerComponent,
        DatePickerComponent,
        DocConfirmationComponent,
        BlockElementComponent
    ],
    providers: [
        {
            provide: NgbDateParserFormatter,
            useClass: CustomNgbDateParserFormatter,
            deps: [ Store ]
        }
    ]
})
export class SharedStageComponentsModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: SharedStageComponentsModule,
            providers: []
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/stage/containers/sharedComponents.module.ts